import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import React, { useEffect } from "react";
import "../../../Sass/Common.scss";
import { PrimaryDialogTitle } from "./DialogComponents";
import { ReactComponent as DeleteRoundIcon } from "../../../Assets/Icons/PharmsmartIcon/DeleteRoundIcon.svg";
import { ReactComponent as ErrorIcon } from "../../../Assets/Icons/PharmsmartIcon/ErrorIcon.svg";
//import { ReactComponent as Urgent } from "../../../Assets/Icons/PharmsmartIcon/Urgent.svg";
import { makeStyles } from "@mui/styles";
import PrimaryIcon from "../../../Components/Common/PrimaryIcon";
import clsx from "clsx";
// html-react-parser removed: template literal replaced with safe JSX
const useStyle = makeStyles((theme) => ({
  resConfirmationBox: {
    "&>div": {
      "&>div": {
        "&>h3": {
          marginTop: "30px !important",
          color: "red !important",
        },
      },
      "&>div": {
        "&>h4": {
          marginTop: "25px",
        },
      },
    },
  },
  dialogActionBtn: {
    paddingBottom: "0 !important",
    paddingTop: "0 !important",
    border: "0 !important",
  },

  TextBlack: {
    color: "#333 !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    width: "70%",
    margin: "0 auto !important",
  },
  TextBlackMultiple: {
    color: "#333 !important",
    fontSize: "18px !important",
    fontWeight: "600 !important",
    width: "70%",
    paddingRight: "2px",
    paddingLeft: "2px",
    whiteSpace: "nowrap",
  },
  dialogWidth: {},
  assignmultiple: {
    maxWidth: "100%",
    display: "flex",
    listStyle: "none",
    flexWrap: "wrap",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    "&>p": {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "fit-content",
    },
  },
  multipleList: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "center",
  },
  colorREd: {
    color: "#ff5a5a !important",
  },
  rsIconDesign: {
    "&>div": {
      "&>div": {
        "&>svg": {
          width: "32px",
          height: "32px",
        },
      },
      "&>h2": {
        fontSize: "18px !important",
        fontWeight: "600 !important",
      },
    },
  },
}));

const MultipleDeletePatient = (props) => {
  const classes = useStyle();
  const {
    open,
    setOpen,
    title = "",
    body,
    actionBtnTitle = "",
    handleSubmit = () => {},
    loading = false,
    getPatientAllDeletePatientAction,
    deleteAllPatientData,
  } = props;

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open) {
      getPatientAllDeletePatientAction();
      console.log(
        "deleteAllPatientData",
        deleteAllPatientData?.data?.data?.patients_order_count,
        deleteAllPatientData?.data?.data?.patient_delete_count,
        deleteAllPatientData?.data?.data?.patient_delete_count +
          deleteAllPatientData?.data?.data?.patients_order_count
      );
    }
  }, [open]);

  return (
    <>
      <Box className={classes.ModalHeading}>
        <Dialog
          className="RSxs_modal"
          maxWidth={"xs"}
          open={open}
          onClose={(e) => {
            if (e.key === "Escape") {
              handleClose();
            }
          }}
          BackdropProps={{
            classes: {
              root: "root",
            },
          }}
        >
          <Box
            className={clsx(
              classes.rsIconDesign,
              "ConfirmPrimaryDialogTitleBlack"
            )}
          >
            <PrimaryDialogTitle
              // handleClose={handleClose}
              icon={DeleteRoundIcon}
              title={"Delete Patients?"}
            />
          </Box>
          <Box className={clsx("rsNoteGrid", classes.resConfirmationBox)}>
            <DialogContent className="DialogContentBoxView">
              <Box
                className="ModalIconWidth"
                textAlign={"center"}
                justifyContent={"center"}
              >
                <>
                  <Box>
                    <Typography>
                      Are you sure you want to delete{" "}
                      {deleteAllPatientData?.data?.data?.patient_delete_count}{" "}
                      patients?
                      <br />
                      &nbsp;{" "}
                      <b>
                        ({deleteAllPatientData?.data?.data?.patients_order_count}{" "}
                        out of{" "}
                        {(deleteAllPatientData?.data?.data?.patient_delete_count ?? 0) +
                          (deleteAllPatientData?.data?.data?.patients_order_count ?? 0)}{" "}
                        patient will not be deleted as they are assigned to repeated orders).
                      </b>
                    </Typography>
                  </Box>
                  <Box>
                    {deleteAllPatientData?.data?.data?.patients_order_count ==
                    deleteAllPatientData?.data?.data?.patient_delete_count +
                      deleteAllPatientData?.data?.data?.patients_order_count ? (
                      <Typography className={classes.colorREd}>
                      You can’t delete all patients. They have repeat orders & collections.
                      </Typography>
                    ) : (
                      <Typography className={classes.colorREd}>
                        You won't be able to undo this!
                      </Typography>
                    )}
                  </Box>
                </>
              </Box>
            </DialogContent>
            <DialogActions className={classes.dialogActionBtn}>
              {actionBtnTitle && (
                <Button
                  className={
                    deleteAllPatientData?.data?.data?.patients_order_count !==
                    deleteAllPatientData?.data?.data?.patient_delete_count +
                      deleteAllPatientData?.data?.data?.patients_order_count
                      ? "BtnRedBg"
                      : ""
                  }
                  variant="contained"
                  disabled={
                    loading ||
                    deleteAllPatientData?.data?.data?.patients_order_count ==
                      deleteAllPatientData?.data?.data?.patient_delete_count +
                        deleteAllPatientData?.data?.data?.patients_order_count
                  }
                  startIcon={
                    loading && <CircularProgress size="20px" color="white" />
                  }
                  onClick={() => handleSubmit()}
                >
                  {actionBtnTitle}
                </Button>
              )}
              <Button
                variant="outlined"
                onClick={handleClose}
                className="BtnRed"
              >
                No, Close
              </Button>
            </DialogActions>
          </Box>
        </Dialog>
      </Box>
    </>
  );
};

export default MultipleDeletePatient;
